import React, {useEffect, useState} from 'react'
import BackButton from 'components/BackButton'
import { useRouteMatch } from "util/router.js";
import {apiRequest} from 'util/api/util'
import Card from 'react-bootstrap/Card';
import Avatar from 'react-avatar'
import {useAuth} from 'util/auth'
import Spinner from 'react-bootstrap/Spinner'
import * as moment from 'moment-timezone'
import ReactTable from "react-table";
import Button from 'react-bootstrap/Button';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton'
import Modal from 'react-bootstrap/Modal'
import { useForm, Controller } from "react-hook-form";
import * as yup from 'yup';
import {useSelector } from 'react-redux';
import FormGroup from 'components/Form/FormGroup'
import FormDatePicker from 'components/Form/FormDatePicker'
import StatusPill from 'components/StatusPill'
import { DevTool } from "react-hook-form-devtools";
import PaymentMethods from 'components/Clients/PaymentMethods'

const DATE_FORMAT = 'ddd MMM D, YYYY';

function ClientReservations({reservations, ...otherProps}) {

    const data = reservations.sort( (a, b) => {
            if (a.created && b.created) {
                return b.created - a.created
            } else {
                return 0
            }
            // if (a.classStartTime && b.classStartTime) {
            //     return b.classStartTime - a.classStartTime
            // } else {
            //     return 0
            // }
        })
        .map(val => {
            return {
            ...val,
            // payment: payment,
            // title: title,
            paid: val.canceled ? "canceled" : val.paid,
            student_name: `${val.firstName} ${val.lastName}`
            }
        })
    return (
        <div>
            <div className="d-flex flex-row-reverse">
            {/* <Button onClick={handleExport} size={"sm"}>Export to CSV</Button> */}
            <div id='export-reservations-div'></div>
            </div>
            <h4>Client History: {reservations?.length}</h4>
            <ReactTable
                    loading={false}
                    data={data}
                    filterable
                    columns={[
                        // {
                        //     Header: "id",
                        //     accessor: "id",
                        //     // filterable: false,
                        //     sort: 'desc',
                        //     },
                        {
                        Header: "Date Purchased",
                        accessor: "created",
                        // filterable: false,
                        sort: 'desc',
                        Cell: row => <span>{moment(row.value * 1000).format('MMMM Do, h:mm a')}</span>
                        },
                        {
                        Header: "Type",
                        accessor: "locationType",
                        width: 100
                        },
                        {
                        Header: "Name",
                        accessor: "className"
                        },
                        {
                        Header: "Class Time",
                        accessor: "classStart"
                        },
                        // {
                        // Header: "Student",   
                        // accessor: "student_name"
                        // },
                        // {
                        // Header: "Email",
                        // accessor: "email"
                        // },
                        {
                        Header: "Purchase Type",
                        // id: 'reservationType',
                        accessor: "reservationType",
                        width: 100
                        },
                        {
                        Header: "Paid",
                        accessor: "paid",
                        width: 50
                        },
                        {
                        Header: "Package Name",
                        accessor: "purchaseName",
                        width: 160
                        },
                        // {
                        // Header: "Status",
                        // accessor: "status",
                        // width: 100
                        // },
                        // {
                        // Header: "Actions",
                        // accessor: "actions",
                        // width: 100
                        // }
                    ]}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom={true}
                    className="-highlight"
                    />
            </div>
        );

}

function ClientPurchases({isLoading, purchases, ...otherProps}) {

    const ONE_YEAR_FROM_NOW = moment().add(1, 'year').unix()
    const THREE_YEARS_FROM_NOW = moment().add(3, 'year').unix()

    const [showAll, setShowAll] = useState(false)

    const data = purchases.map(val => {

        if (!val) {
            console.log("val: ", val)
            return {}
        }
        const NOW = moment().unix()
        const ONEYEAR = moment().add(1,'y').unix()
        const expirationDate = val?.expires ? moment(val.expires * 1000) : moment().add(5,'y')

        const isExpired = (val?.expires ?? 0) < NOW

        let canBeUsed = true

        if (isExpired) {
            canBeUsed = false
        }

        if (val?.offering?.type === 'pack' && val?.remaining <= 0) {
            canBeUsed = false
        }

        return {
            canBeUsed: canBeUsed,
            purchaseId: val?.id,
            name: val?.offering?.name,
            // email: val.user.email,
            // created: val.created,
            created: val.created,
            expires: val.expires,
            status: ["pack", "challenge"].includes(val?.offering?.type ?? "") ? (
                <>
                    { val.expires < ONEYEAR ? (
                        <span>
                            {`${val.expires > NOW ? "Expires" : "Expired"} ${expirationDate.format("LL")}`}
                        </span>
                    ) : <span>Never expires</span>}
                </>
                ) : (
                <>
                    {(!isExpired && !val.canceled) ? (<StatusPill text={"renews " + expirationDate.format("l")} status="green"/>) : null}
                    {isExpired ? (<StatusPill text={"expired " + expirationDate.format("l")} status="red"/>) : null}
                    {(!isExpired && val.canceled) ? (<StatusPill text={`cancels ${expirationDate.format('l')}`} status="yellow"/>) : null}
                    {/* {val.canceled ? `${val.expires > NOW ? "Expires" : "Expired"}` : "Renews"}&nbsp;{expirationDate.format("l")} */}
                </>
            ),
            remaining: val?.offering?.type === "pack" ? (
            <>
                <span>{val.remaining}</span><br></br>
            </>
            ) : (
            <>
                <span>{val.remaining > 100 ? "Unlimited" : `${val.remaining}`}</span>
            </>
            ),
            actions: (
                // we've added some custom button actions
                <div className="actions-right">
                    <EditPurchase purchase={val} 
                    handleEdit={otherProps.handleEdit}
                    />
                </div>
              )
        }
    }).filter(val => {
        if (showAll) {
            return true
        }

        return val.canBeUsed
    })


    return (
    <div>
        <div className="d-flex d-row align-items-center">
            <h4 className="mr-2">Packages &amp; Subscriptions</h4>
            <button type="button" className="btn btn-link"
                onClick={() => {
                    setShowAll(!showAll)
                }}
            >
                {showAll ? "Hide expired" : "Show all"}
            </button>
        </div>
        
        <ReactTable
        loading={isLoading}
                data={data}
                filterable={false}
                columns={[
                    {
                    Header: "Name",
                    accessor: "name",
                    sort: 'desc'
                    },
                    // {
                    // Header: "purchase id",
                    // accessor: "purchaseId",
                    // sort: 'desc'
                    // },
                    {
                    Header: "Date Purchased",
                    accessor: "created",
                    sort: 'desc',
                    Cell: row => (
                        <div>
                            <h6>{moment(row.value * 1000).format("dddd MMM Do")}</h6>
                            <div>{moment(row.value * 1000).format("h:mm a")}</div>
                        </div>
                    ),
                    },
                    {
                    Header: "Remaining",
                    accessor: "remaining",
                    sort: 'desc',
                    },
                    {
                    Header: "Status",
                    accessor: "status",
                    sort: 'desc',
                    },
                    {
                    Header: "Expiration/Renewal Date",
                    accessor: "expires",
                    sort: 'desc',
                    Cell: row => 
                    row.value > THREE_YEARS_FROM_NOW ? (<span>Never</span>) :
                    (
                        
                        <div>
                            <h6>{moment(row.value * 1000).format("dddd MMM Do, YYYY")}</h6>
                        </div>
                    ),
                    },
                    {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                    }
                ]}
                pageSize={data?.length ?? 5}
                // defaultPageSize={data?.length ?? 5}
                showPaginationTop={false}
                showPaginationBottom={false}
                className="-highlight"
                  />
    </div>
    )
}

function EditPurchase(props) {

    const {purchase} = props

    const [open, setOpen] = React.useState(false)
    const [isSaving, setIsSaving] = React.useState(false)

    const { register, control, handleSubmit, setValue, getValues, formState, errors } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            remaining: yup.number(),
            expirationDate: yup.string(),
        }),
        defaultValues: {
            remaining: purchase?.remaining ?? 0,
            expirationDate: purchase?.expires ? moment(purchase.expires * 1000).format(DATE_FORMAT) : null
        }
    });

    const onSubmit = (data) => {

        data = {
            ...data,
            id: purchase.id
        }
        
        console.log(data)
        if (data.expirationDate) {
            data.expirationDate = moment(data.expirationDate, DATE_FORMAT).endOf('day').unix()
            data.expires = data.expirationDate
            delete data.expirationDate
        } 
        
        console.log(data)

        if (props.handleEdit) {
            setIsSaving(true)
            props.handleEdit(data, function() {
                setIsSaving(false)
                setOpen(false)
            })
        }


    }

    const handleCancelation = () => {

        if (props.handleEdit) {
            setIsSaving(true)
            props.handleEdit({
                canceled: true,
                id: purchase.id
            }, function() {
                setIsSaving(false)
                setOpen(false)
            })
        }
    }

    const handleEdit = () => {

        setOpen(true)
    }

    return (<>
        <Modal
            centered
            // className={"modal-container custom-map-modal"}
            size="lg"
            // {...props}
            show={open}
            keyboard={false}
            backdrop={'static'}
            onHide={() => setOpen(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{purchase?.offering?.name}</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Body className="container">
                    <FormGroup
                        type="number"
                        name="remaining"
                        label="Remaining"
                        register={register}
                        error={errors.remaining}
                        prepending={["classes"]}
                        fullSize
                    />
                    {(['pack', 'challenge'].includes(purchase?.offering?.type) || (purchase?.offering?.type === 'subscription' && purchase?.canceled === true)) && (
                        <FormDatePicker
                            fullSize
                            name="expirationDate"
                            label="Expiration Date"
                            placeholder="Select date"
                            getValues={getValues}
                            control={control}
                            dateFormat={DATE_FORMAT}
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {(purchase?.offering?.type === 'subscription' || purchase?.offering?.isSubscription) && (
                        <Button 
                        type="button" 
                        variant="primary" 
                        disabled={isSaving || purchase.canceled}
                        onClick={handleCancelation}
                        >
                            <span>{purchase.canceled ? "Subscription Canceled" : "Cancel Subscription"}</span>
                            {isSaving && (
                                <Spinner
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden={true}
                                    className="ml-2"
                                >
                                <span className="sr-only">Sending...</span>
                            </Spinner>

                            )}
                        </Button>
                    )}
                    
                    <Button type="submit" variant="primary" disabled={isSaving}>
                        <span>Save changes</span>
                        {isSaving && (
                            <Spinner
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden={true}
                                className="ml-2"
                            >
                            <span className="sr-only">Sending...</span>
                        </Spinner>

                        )}
                    </Button>
                </Modal.Footer>
                </form>
                
        </Modal>
        <IconButton onClick={() => handleEdit()}>
            <EditIcon/>    
        </IconButton>
    </>)
}

function ClientPage(props) {

    const NOW_TIMESTAMP = moment().unix()

    const auth = useAuth()
    const match = useRouteMatch();

    const selectedUserId = match.params.userId
    const partnerId = useSelector(state => state.user.userData.platformID);
    // const clients = useSelector(state => state.clients.clients)
    // const selectedUser = useSelector(state => state.clients.clients.find(el => el.id === match.params.userId))

    const [clientData, setClientData] = React.useState(null)
    const [reservations, setReservations] = React.useState([])
    const [purchases, setPurchases] = React.useState([])
    // const [paymentMethods, setPaymentMethods] = React.useState([])
    const [isLoading, setIsLoading] = React.useState(true)

    const { register, control, handleSubmit, setValue, formState, errors, dirty, getValues, watch } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            notes: yup.string()
        }),
        defaultValues: {
            notes: ""
        }
    });

    const [isSaving, setIsSaving] = React.useState(false)
    const [editMode, setEditMode] = React.useState(false)
    const onSubmit = (data) => {

        setIsSaving(true)

        apiRequest(
            `clients/updateClient`,
            "POST",
            {
                clientId: selectedUserId,
                partnerId: partnerId,
                clientInfo: {
                    ...data
                }
            })
            .then(updatedClient => {
                setEditMode(false)
                setClientData(updatedClient)
                setIsSaving(false)
                setValue('notes', updatedClient?.notes ?? "")
                
            })
            .catch(err => {
                setIsSaving(false)
                console.log(err)
                window.alert("something went wrong updating")

            })

    }

    useEffect(() => {

        if (!selectedUserId || !auth.userData || !partnerId) {
            console.log("instructor: ", partnerId)
            return
        }

        console.log("making request")
        apiRequest(`clients/getClient?clientId=${selectedUserId}&partnerId=${partnerId}`, "POST", {
            clientId: selectedUserId,
            partnerId: partnerId
        })
            .then(data => {
                console.log("Client Data: ", data)
                let {user, purchases, reservations} = data
                setClientData(user)
                setPurchases(purchases)
                setReservations(reservations)
                // setPaymentMethods(paymentMethods)
                setIsLoading(false)
                setValue('notes', user?.notes ?? "")
            })
            .catch(err => {
                setIsLoading(false)
            })

    }, [partnerId])

    const handleEditPurchase = (data, onFinished) => {
        // console.log(data)
        console.log("Handle edit purchase: ", data)
        const purchaseId = `${data.id}`
        delete data.id
        apiRequest(
            `clients/purchases?clientId=${selectedUserId}&purchaseId=${purchaseId}`,
            "PUT",
            {purchase: {
                ...data
            }})
            .then(updatedPurchase => {
                const {id} = updatedPurchase
                var copyOfPurchases = [...purchases]
                const index = copyOfPurchases.findIndex(val => val.id === id)
                if (index !== -1) {
                    copyOfPurchases[index] = updatedPurchase
                }

                setPurchases(copyOfPurchases)
                onFinished()
            })
            .catch(err => {
                console.log(err)
                onFinished()
                window.alert("something went wrong updating")

            })
            
    }

    const purchaseData = purchases.map(val => {
        if (val?.expires && val.expires < NOW_TIMESTAMP) {
            val.expired = true
            val.statusText = `Expired ${moment(val.expires * 1000)}`
        } 
        return val
        // else if 
    })

    const viewModel = {
        image: clientData?.profileImageUrl,
        name: (clientData?.firstName ?? "") + " " + (clientData?.lastName ?? ""),
        email: clientData?.email,
        purchases: purchaseData,
        injuries: clientData?.injuries,
        notes: clientData?.notes
    }

    return (<>
    <div className="px-sm-0 px-md-5">
    <BackButton className="mb-3" />
    {isLoading ? (

        <Spinner
        animation="border"
        size="sm"
        role="status"
        aria-hidden={true}
        className="ml-2"
        >
        <span className="sr-only">Loading...</span>
        </Spinner>
        
    ) : (
    <div className="row">
        <div className="mb-4 col-sm-12 col-md-3">

            <Avatar className="mr-2 mb-4" src={viewModel.image} name={viewModel.name} size={80} round="60px"/>
            <div className="mb-4">
                <h5 className="font-weight-bold">{viewModel.name}</h5>
                <a href={`mailto:${viewModel.email}`} target="_blank">{viewModel.email}</a>
            </div>
            {viewModel.injuries && (

                <div className="mb-4">
                    <h5 className="font-weight-bold">Injuries</h5>
                    <p>{viewModel.injuries}</p>
                </div>

            )}

            {(<>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-4">
                        <div className="d-flex d-row align-items-center">
                            <h5 className="mr-1">Notes</h5>
                            <button type="button" className={"btn btn-link " + (editMode ? "d-none" : "")}
                                onClick={() => {
                                    setEditMode(true)
                                }}
                            >
                                Edit
                            </button>
                        </div>
                        <p style={{whiteSpace: "pre-wrap"}} className={(editMode ? "d-none" : "")}>{viewModel.notes}</p>
                        <textarea ref={register} name="notes" type="text" class={"form-control rounded-0 " + (editMode ? "" : "d-none") } id="client-notes" rows="10"></textarea>
                    </div>
                    
                    <button type="submit" className={"btn btn-primary " + (editMode ? "" : "d-none")} disabled={isSaving}>
                        <span>Save</span>
                        {isSaving && (
                            <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden={true}
                            className="ml-2"
                        >
                        </Spinner>

                        )}
                    </button>
                </form>
                <DevTool control={control} />
                
                </>
            )}


        </div>
        {/* <Card className="mb-4 col-3">
            <Card.Body>
                <div>
                    <div className="d-flex d-row align-items-center">
                        
                    </div>
                
                </div>
            </Card.Body>

        </Card> */}
        <div className="col-sm-12 col-md-9">

            <div className="mb-5">
                <ClientPurchases 
                    isLoading={false}
                    purchases={viewModel.purchases}
                    handleEdit={handleEditPurchase}
                />
                <hr></hr>
            </div>

            <div className="mb-5">
                
                <PaymentMethods
                    clientId={selectedUserId}
                />
                <hr></hr>
            </div>
            
            <div className="mb-5">

                
                <ClientReservations 
                reservations={reservations}
                />
                <hr></hr>
            </div>
            
            
            
        </div>
        

    </div>)}
    </div>
    </>)
}

export default ClientPage;